/**
 * isStreamStatus - Returns a boolean flag determined by an exact string match between the
 * stream.status property and the statusType string parameter.
 *
 * @param {object} streamObject - Object containing the status string property
 * @param {string} statusType - Represents the statusType to match
 *
 * @return {boolean} Returns true if the stream.status property matches the statusType; false otherwise.
 */
export default function isStreamStatus({ status } = {}, statusType = '') {
    return (typeof status === 'string' && status.trim() !== '' && statusType !== '' && statusType === status);
};



// WEBPACK FOOTER //
// ./app/lib/auth/isStreamStatus.js